import { FC, useCallback } from "react";
import * as EigenReact from "@data-root/react";
// import { SchemaItemProps, useField } from "@data-root/react";
import { SchemaItem } from "@data-root/types";
import { SyncOutlined, ExperimentOutlined } from "@ant-design/icons";
import { Button, Tooltip } from "antd";
import { View } from "@data-root/react";
import { withErrorBoundary } from "./withErrorBoundary";

export const LazyPlaceholder: FC<EigenReact.SchemaItemProps> = ({ item }) => {
  const { lazy } = EigenReact.useField(item);

  const onClick = useCallback(() => {
    lazy();
  }, [lazy]);

  return (
    <View>
      <Button onClick={onClick} type="primary" icon={<ExperimentOutlined />}>
        {item.name} (lazy)
      </Button>
    </View>
  );
};

export const inputLazyGuard =
  <T extends SchemaItem>(
    Component: FC<EigenReact.SchemaItemProps<T>>
  ): FC<EigenReact.SchemaItemProps<T>> =>
  (props) => {
    const { item } = props;
    const { value, lazy, show } = EigenReact.useField(item);

    const hasValue = value !== null && value !== undefined;
    const isLazy = "lazy" in item ? item.lazy : false;

    const onClick = useCallback(() => {
      lazy();
    }, [lazy]);

    if (!show) return null;

    return !hasValue && isLazy ? (
      <LazyPlaceholder {...props} />
    ) : isLazy ? (
      <View
        style={{
          backgroundColor: "#eeeeee",
          padding: 10,
          width: "100%",
        }}
      >
        <Tooltip key="sync" title="Refrescar">
          <Button type="primary" icon={<SyncOutlined />} onClick={onClick} />
        </Tooltip>

        <Component {...props} />
      </View>
    ) : (
      <Component {...props} />
    );
  };

export const inputGuard = <T extends SchemaItem>(
  Component: FC<EigenReact.SchemaItemProps<T>>
): FC<EigenReact.SchemaItemProps<T>> =>
  withErrorBoundary(inputLazyGuard(Component));
